<template>
    <el-col :span="24" class="pcr-current-title">
        <!-- <div v-if="!current">
            <h1>Veuillez sélectionner l'établissement à administrer</h1>
        </div> -->
        <div v-if="current">
            <h1><span v-if="current.Type == 'User'">Utilisateur : </span>{{ title }}</h1>
        </div>
    </el-col>
</template>

<script>
import Vue from 'vue';
export default Vue.component('pcr-current-title', {
    props: {
        current: {
            type: Object,
            default: () => null
        },
    },
    data() {
        return {
            title: ''
        }
    },
    computed: {
    },

    mounted: function () {
    },
    methods: {
    },

    watch: {
        current(val) {
            this.title = val.Label;
            setTimeout(() => {
                this.title = val.Label;
            }, 200)
        }
    }
});
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/visual/pcr-current-title.vue